export default __webpack_public_path__ + "static/media/desktop_85.4dc1bcea.jpg";